import { LayoutService } from '../service/layout.service';
import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSidebar } from './app.sidebar';
import { AppTopbar } from './app.topbar';
import { AppConfigurator } from './app.configurator';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, AppTopbar, AppSidebar, RouterModule, AppConfigurator],
  template: `<div class="layout-wrapper" [ngClass]="containerClass()">
    <div app-sidebar [module]="module"></div>
    <div class="layout-content-wrapper">
      <div class="layout-content-wrapper-inside">
        <div app-topbar></div>
        <div class="layout-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <app-configurator />
    <div class="layout-mask"></div>
  </div> `
})
export class AppLayout {
  @Input() module: string | null = null;

  layoutService = inject(LayoutService);

  constructor() {
    effect(() => {
      const state = this.layoutService.layoutState();
      if (state.mobileMenuActive) {
        document.body.classList.add('blocked-scroll');
      } else {
        document.body.classList.remove('blocked-scroll');
      }
    });
  }

  containerClass = computed(() => {
    const layoutConfig = this.layoutService.layoutConfig();
    const layoutState = this.layoutService.layoutState();

    return {
      'layout-overlay': layoutConfig.menuMode === 'overlay',
      'layout-static': layoutConfig.menuMode === 'static',
      'layout-slim': layoutConfig.menuMode === 'slim',
      'layout-horizontal': layoutConfig.menuMode === 'horizontal',
      'layout-compact': layoutConfig.menuMode === 'compact',
      'layout-reveal': layoutConfig.menuMode === 'reveal',
      'layout-drawer': layoutConfig.menuMode === 'drawer',
      'layout-overlay-active': layoutState.overlayMenuActive,
      'layout-mobile-active': layoutState.mobileMenuActive,
      'layout-static-inactive': layoutState.staticMenuInactive,
      'layout-sidebar-expanded': layoutState.sidebarExpanded,
      'layout-sidebar-anchored': layoutState.anchored,
      [`layout-card-${layoutConfig.cardStyle}`]: true,
      [`layout-sidebar-${layoutConfig.menuTheme}`]: true
    };
  });
}
